import {createElement} from 'react'
import {nanoid} from 'nanoid'
import {toast} from 'react-toastify'
import {Observable} from 'rxjs'

import {FileDownloadIcon} from 'components/Basic/SvgIcon/Native'
import Toast from 'components/Basic/Toast'
import {i18n} from 'i18n'

export const DOWNLOAD_IN_PROGRESS_TOAST_DELAY_MS = 3000

const showDownloadInProgressToast = (toastId: string): void => {
  Toast({
    message: i18n.t('analytics:ANALYTICS_DOWNLOAD_IN_PROGRESS'),
    type: 'info',
    icon: createElement(FileDownloadIcon),
    customId: toastId,
    autoClose: false,
    multipleToast: true,
  })
}

/**
 * Warns that a download is still pending, then removes that warning when the
 * request settles so a file, an empty export, or an error can speak for itself.
 * Each subscription owns its toast, so one download cannot clear another's.
 */
export const withDownloadInProgressToast = <T>(
  source: Observable<T>,
): Observable<T> =>
  new Observable(subscriber => {
    const toastId = `analytics-download-in-progress-${nanoid()}`
    const timeoutId = setTimeout(
      () => showDownloadInProgressToast(toastId),
      DOWNLOAD_IN_PROGRESS_TOAST_DELAY_MS,
    )
    const subscription = source.subscribe({
      next: value => subscriber.next(value),
      error: error => subscriber.error(error),
      complete: () => subscriber.complete(),
    })

    return () => {
      clearTimeout(timeoutId)
      toast.dismiss(toastId)
      subscription.unsubscribe()
    }
  })
